import { type Context, createContext } from 'react';

import { type CartType } from '@jsmdg/cart-library-ts';
import { type AddToCartClickParams, type HandleAddToCartClick } from '../hooks/useBuybox';

export type OverlayContextType = {
    wrapAddToCartWithOverlay: (
        handleAddToCartClick: HandleAddToCartClick,
        params: AddToCartClickParams,
    ) => Promise<void>;
    closeCartSelectionOverlay: () => void;
    isOpen: boolean;
    onRequestClose: () => void | Promise<void>;
    onContinueShopping: () => void;
    onCheckout: () => void;
    initialCart: CartType | null;
    itemId?: string;
};

export const overlayContextCreate = (): Context<OverlayContextType> => {
    return createContext<OverlayContextType>({
        wrapAddToCartWithOverlay: async () => {},
        closeCartSelectionOverlay: () => {},
        isOpen: false,
        onRequestClose: () => {},
        onContinueShopping: () => {},
        onCheckout: () => {},
        initialCart: null,
        itemId: undefined,
    });
};

export const OverlayContext = overlayContextCreate();
